// @ts-nocheck
/* eslint-disable */
import { dateFormat } from "~/util/format";
import { _ } from "~/i18n";

/**
 * Provede lokalizaci čísla podle místních zvyklostí.
 * @param {Number|String} number Číslo k lokalizaci
 * @returns {String}
 */
Mapy.Util.formatLocaleNumber = function(number) {
	var number = new Number(number);
	var out = number.toString();
	out = out.replace('.', _("separators.decimal")).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + _("separators.thousand"));
	return out;
};

/**
 * Formatovani cisla - 10.010000, d 3 -> 10.01, 10.1234 d 3 -> 10.123
 * Pokud chci 3 desetinna mista a je tam cele cislo, nuly se zrusi
 *
 * @param  {Number} number Vstupni cislo
 * @param  {Number} decimals Pocet desetinnych mist
 * @param  {Bool} [skipLocale = false] Nahradit desetinnou tečku?
 * @param  {Bool} [preserveZeroes = false] U cisla 4.0 -> 4.0 ponechat nully
 * @returns {String}
 */
Mapy.Util.formatNumber = function(number, decimals, skipLocale, preserveZeroes) {
	var value = number.toFixed(decimals);

	if (!preserveZeroes) {
		value = value.replace(new RegExp("\\.0+$"), "");
	}

	if (!skipLocale) {
		//var separator = (1.1).toLocaleString().substr(1, 1);
		// nahradime separator dle jazyku
		value = value.replace('.', _("separators.decimal")).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + _("separators.thousand"));;
	}

	return value;
};

/**
 * vezme adresu ve formatu, jaky prijde u POIe v objektu extend.address a vrati polozky adresy oddelene carkami
 * @param {Object} address
 * @returns {string}
 */
Mapy.Util.formatAddress = function(address, zip) {
	var label = [];

	if (address.lines) {
		label = address.lines.splice(0, 2);
	} else {
		if (address.street || ((address.city || address.ward) && address.house_num)) {
			label.push((address.street || address.ward || address.city) + (address.house_num ? " " + address.house_num : ""));
		}
		if (address.street && address.city) {
			if (zip && address.zip) {
				label.push(address.zip + " " + address.city);
			}
			else {
				label.push(address.city);
			}
		}
		if (address.district) { label.push(address.district); }
		if (!address.district && address.region) { label.push(address.region); }
		if (!address.region && address.country) { label.push(address.country); }
	}

	return label.join(", ");
}

/**
 * Formátuje plochu dle požadovaných pravidel.
 * @param {int} value plocha v metrech
 */
Mapy.Util.formatArea = function(value) {
	var KM_2 = 1000*1000;
	var unit = "m";
	var dec = (value <= 250000 ? 0 : (value <= KM_2 ? 3 : (value <= 25 * KM_2 ? 2 : (value <= 1000 * KM_2 ? 1 : 0))));
	var isMax = value > Math.pow(10, 6) * KM_2;
	var show = value > 0 && !isMax;

	if (value > 250000) {
		value = value / KM_2;
		unit = "km";
	}

	return {
		value: Mapy.Util.formatLocaleNumber(Mapy.Util.formatNumber(value, dec, true)),
		unit: unit,
		full: value + String.fromCharCode(160) + unit,
		show: show
	};
};

/**
 * Formátuje čas dle požadovaných pravidel.
 * @param {int} t čas v minutách
 * @param {Bool} [noPadding = false] dodat nuly minut u celých hodin?
 */
Mapy.Util.formatPTminutes = function (t, noPadding) {
	var h = parseInt(t / 60).toString();
	if (!noPadding) { h = h.lpad("0", 2); }
	var m = ":" + parseInt(t % 60).toString().lpad("0", 2);
	if (noPadding && parseInt(t % 60) == 0) { m = ""; }
	return h + m;
}

/**
 * Převede datum v objektu Date na lokálně formátovaný datum. Použije lokální čas.
 * @param {Date} date objekt Date k převedení na řetězec
 * @param {Bool} [time = false] Vracet včetně času?
 * @param {Bool} [seconds = true] Vracet včetně sekund?
 * @returns {String}
 */
Mapy.Util.dateToLocaleFormatLocal = function (date, time, seconds) {
	time = time || false;
	seconds = seconds ? true : false;
	var y = date.getFullYear().toString();
	var m = (date.getMonth() + 1).toString().toString().lpad("0", 2);
	var d = date.getDate().toString().lpad("0", 2);
	var H = date.getHours().toString().lpad("0", 2);
	var M = date.getMinutes().toString().lpad("0", 2);
	var S = date.getSeconds().toString().lpad("0", 2);

	return time ? d + "." + m + "." + y +  " " + H + ":" + M + (seconds ? ":" + S : "") : d + "." + m + "." + y;
}

/**
 * Vrátí minuty v desetinném formátu zaokrouhlené na danou pozici
 * @param {type} date Datum pro získání minut
 * @param {Int, Boolean} [precision = false] přesnost zaokrouhlení
 * @returns {Number}
 */
Mapy.Util.minutesToDecimal = function (date, precision) {

	switch (typeof precision) {
		case "number":
			break;
		case "boolean":
			if (precision) {
				precision = 0;
			}
			break;
		case "undefined":
			precision = false;
			break;
		default:
			return;
	}

	var M = date.getMinutes();
	var S = date.getSeconds() / 60;
	var minutes = M + S;

	if (precision || precision === 0) {
		var factor = Math.pow(10, precision);
		var tempNumber = minutes * factor;
		var roundedTempNumber = Math.round(tempNumber);
		return roundedTempNumber / factor;
	} else {
		return minutes;
	}
};

/**
 * vezme adresu ve formatu, jaky prijde u POIe v objektu extend.address a vrati polozky adresy oddelene carkami (dle starých pravidel)
 * @param {Object} address
 * @returns {string}
 */
Mapy.Util.getAddress = function(poi) {
	var lines = [];
	var A = poi;

	if (A.zip && A.zip.length == 5) {
		A.zip = A.zip.substring(0, 3) + " " + A.zip.substring(3);
	}

	/* struktura vypisovani podle http://cml.kancelar.seznam.cz/mapy/ticket/4689 */
	/* 1. radek */
	/* pokud by bylo jen mesto, ale uz ne ulice a ani cislo domu, pak nevypiseme nic, nazev mesta bude (pokud je) v dalsim radku uveden */
	if (A.street || ((A.city || A.ward) && A.house_num)) {
		lines.push((A.street || A.ward || A.city) + (A.house_num ? " " + A.house_num : ""));
	}
	/* 2. radek */
	/* pokud je PSC, oddelime ho dvema mezerami od zbytku; pak nasleduje mesto a pokud je ward jiny nez mesto a uvedeny, tak ward (neboli cast mesta) */
	if (A.zip || A.city || A.ward) {
		var line = (A.zip || "") + (A.zip && (A.city || A.ward) ? "&nbsp;&nbsp;" : "");

		// mam ctvrt, pouziji primarne ji, pripadne doplnim o nazev mesta pokud neni v nazvu ctvrti
		if (A.quarter) {
			line += (A.quarter.indexOf(A.city) == -1 ? A.city + "-" : "") + A.quarter.replace("čtvrť ", "");
			line += (A.ward && line.indexOf(A.ward) == -1) ? " &ndash; " + A.ward : "";
		} else {
			line += (A.city || "") + (A.city != A.ward ? (A.city && A.ward ? " &ndash; " : "") + (A.ward ? A.ward : "") : "");
		}

		lines.push(line);
	}

	/* 3. radek */
	/* okres, kraj, stat (pokud to neni CR) */
	var line3 = [];
	if (A.district) { line3.push(A.district); }
	if (A.region) { line3.push(A.region); }
	if (A.country && A.country != "Česká republika") { line3.push(A.country); }
	lines.push(line3.join(", "));

	return lines;
};

/**
 * Date - string format.
 * yyyy - full year; m - month; d - day; s - secods; M - minutes; h - hours;
 * double: dd, ss, MM, hh - left pad with zero.
 *
 * @param  {Date} date Input date
 * @param  {String} [format] Format string
 * @param  {Boolean} [useUTC] Pouzit utc cas?
 * @returns {String}
 */
Mapy.Util.dateFormat = function(date, format, useUTC) {
	return dateFormat(date, format, useUTC);
};

/**
 * Převede objekt Date na ISO string bez časové zóny
 * @param {Date} date datum
 * @returns {String} ISO string
 */
Mapy.Util.dateToISO = function (date) {
	var y = date.getFullYear().toString();
	var m = (date.getMonth() + 1).toString().lpad("0", 2);
	var d = date.getDate().toString().lpad("0", 2);
	var H = date.getHours().toString().lpad("0", 2);
	var M = date.getMinutes().toString().lpad("0", 2);
	var S = date.getSeconds().toString().lpad("0", 2);
	return y + "-" + m + "-" + d + "T" + H + ":" + M+ ":" + S;
};

/**
 * Převede datum v objektu Date na lokálně formátovaný datum. Použije UTC čas
 * @param {Date} date objekt Date k převedení na řetězec
 * @param {Bool} [time = false] Vracet včetně času?
 * @param {Bool} [seconds = true] Vracet včetně sekund?
 * @returns {String}
 */
Mapy.Util.dateToLocaleFormat = function (date, time, seconds) {
	time = time || false;
	seconds = seconds ? true : false;
	var y = date.getUTCFullYear().toString();
	var m = (date.getUTCMonth() + 1).toString().toString().lpad("0", 2);
	var d = date.getUTCDate().toString().lpad("0", 2);
	var H = date.getUTCHours().toString().lpad("0", 2);
	var M = date.getUTCMinutes().toString().lpad("0", 2);
	var S = date.getUTCSeconds().toString().lpad("0", 2);

	return time ? d + "." + m + "." + y +  " " + H + ":" + M + (seconds ? ":" + S : "") : d + "." + m + "." + y;
};

/**
 * Spočíta rozdíl (max. dny) mezi dvěmi daty.
 * @param {object} data Objekt, jaký dodá routovač
 * @returns {int} doba trvání routy v minutách
 */
Mapy.Util.getRouteDurationMinutes = function(data) {
	var departureDate = new Date(data.departureISO);
	var arrivalDate = new Date(data.arrivalISO);
	arrivalDate.setMinutes(Mapy.Util.minutesToDecimal(arrivalDate, 0));

	return Math.ceil(Mapy.Util.timeDiff(departureDate, arrivalDate).minutesTotal);
};

/**
 * Spočíta rozdíl (max. dny) mezi dvěmi daty.
 * @param {Date} date1 první datum
 * @param {Date} date2 druhé datum
 * @returns {Object} Výsledek (vlastnosti s Total je celkový čas)
 */
Mapy.Util.timeDiff = function (date1, date2) {
	var out = {};
	var d1 = date1.getTime(), d2 = date2.getTime();
	out.inFuture = d1 < d2;
	out.milisecondsTotal = Math.abs(d2 - d1);
	out.secondsTotal = out.milisecondsTotal / 1000;
	out.minutesTotal = out.secondsTotal / 60;
	out.hoursTotal = out.minutesTotal / 60;
	out.daysTotal = out.hoursTotal / 24;
	var x = out.daysTotal;
	out.days = Math.floor(x);
	var delta = x - out.days;
	x = delta * 24;
	out.hours = Math.floor(x);
	delta = x - out.hours;
	x = delta * 60;
	out.minutes = Math.floor(x);
	delta = x - out.minutes;
	x = delta * 60;
	out.seconds = Math.floor(x);
	delta = x - out.seconds;
	x = delta * 1000;
	out.miliseconds = Math.floor(x);

	return out;
};

/**
		 * Naformátuje speciálně jednotky pro ruční měření
		 * @param {Number} dist Vzdálenost v metrech
		 * @return {Object} .distance a .unit
		 */
Mapy.Util.formatDistancemeterDistance = function (dist) {
	let distance, unit = "km", km = dist / 1000;
	if (dist < 1000) {
		distance = Math.round(dist);
		unit = "m";
	} else if (dist < 10000) {
		distance = Mapy.Util.formatLocaleNumber(km.toFixed(3));
	} else if (dist < 100000) {
		distance = Mapy.Util.formatLocaleNumber(km.toFixed(2));
	} else if (dist < 1000000) {
		distance = Mapy.Util.formatLocaleNumber(km.toFixed(1));
	} else {
		distance = Mapy.Util.formatLocaleNumber(Math.round(km));
	}
	let string = distance  + String.fromCharCode(160) + unit;
	return {
		distance,
		unit,
		string
	};
};

Mapy.Util.celsiusToFahreint = celsius => {
	return (celsius * 9/5 + 32);
};
